import { Component, OnInit, ViewChild, HostListener, ComponentFactoryResolver, Injector, EmbeddedViewRef, ApplicationRef, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { MenuService } from '../theme/components/menu/menu.service';
import { AuthService } from '../shared/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { ChatService } from './chat/chat.service';
import { ChatP } from './chat/chat.model';
import { SocketService } from '../shared/services/socket.service';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from '../message.service';
import { PushNotificationsService } from '../shared/services/push.notification.service';
import { ChatAdapter } from './ng-chat/core/chat-adapter';
import { NgChat } from './ng-chat/ng-chat.component';
import { IconChatsComponent } from '../theme/components/sidenav/icon-chats/icon-chats.component';
import { DemoAdapter } from './ng-chat/ng-chat.model';
import * as moment from 'moment';
import { XmppService } from '../shared/services/xmpp.service';
import { LogService } from '../shared/services/log.service';

declare var $: any;
declare var webNotification: any;

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [ MenuService, ChatService, SocketService ]
})
export class PagesComponent implements OnInit, OnDestroy { 

  @ViewChild('sidenav') sidenav: any;
  public settings: Settings;
  public menus = ['vertical', 'horizontal'];
  public menuOption: string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption: string;
  public isStickyMenu: boolean = false;
  public lastScrollTop: number = 0;
  public showBackToTop: boolean = false;
  public toggleSearchBar: boolean = false;
  private defaultMenu: string; //declared for return default menu when window resized 
  public scrolledContent: any;
  private canShowNotif: boolean;
  public static chats: ChatP[];
  private socketService;
  public adapter: ChatAdapter = new DemoAdapter();
  @Output() public onMessageReceived: EventEmitter<ChatP> = new EventEmitter<ChatP>();
  public measurer = $('<span>', { style: "display:inline-block;word-break:break-word;visibility:hidden;white-space:pre-wrap;"}).appendTo('body');
  private miniChatinstance: NgChat;
  private xmppService = XmppService.getInstance;

  constructor(public appSettings: AppSettings, public router: Router, private menuService: MenuService, public http: HttpClient, private toastr: ToastrService, private chatService: ChatService,
    private messageService: MessageService, private notificationService: PushNotificationsService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {
    this.settings = this.appSettings.settings;
    //console.log('PAGES_COMPONENT');
    //console.log(AuthService.getThemeSettings());

    // if(this.router.url == '/chat') {
    //   SocketService.userStatus = 1;
    // }

    this.socketService = SocketService.getInstance();
    //this.xmppService.init();
     this.toastr.toastrConfig.preventDuplicates = false;

     
  }

  updateTextAreaSize(textarea){
    textarea.height(this.measurer.height());
    var w = this.measurer.width();
    if(textarea[0].originalOverflowY == "auto"){
    var mw = textarea.css("max-width");
    if(mw != "none"){
    if(w == parseInt(mw)){
    textarea.css("overflow-y", "auto");
    } else {
    textarea.css("overflow-y", "hidden");
    }
    }
    }
    textarea.width(w + 2);
}

initMeasurerFor(textarea){
if(!textarea[0].originalOverflowY){
textarea[0].originalOverflowY = textarea.css("overflow-y");    
}  
var maxWidth = textarea.css("max-width");
this.measurer.text(textarea.text())
.css("max-width", maxWidth == "none" ? textarea.width() + "px" : maxWidth)
.css('font',textarea.css('font'))
.css('overflow-y', textarea.css('overflow-y'))
.css("max-height", textarea.css("max-height"))
.css("min-height", textarea.css("min-height"))
.css("min-width", textarea.css("min-width"))
.css("padding", textarea.css("padding"))
.css("border", textarea.css("border"))
.css("box-sizing", textarea.css("box-sizing"))
}

  ngOnInit() {

    // window.addEventListener('beforeunload', function(event) {
    //   LogService.error('I am the 2nd one.');
    // });

    const xmppService = this.xmppService;
    window.addEventListener('unload', function(event) {
      xmppService.disconnect();
    });


    this.chatService.getChats(AuthService.getUser().id).subscribe(chats => {      
      AuthService.chats = chats;

      this.messageService.loadedChats(true);
      this.setCountIconChats();

      if(this.router.url != '/chat') {
        this.initMiniChatComponent();
      }

      this.socketService.getPresences(AuthService.getUser());

      //console.log(AuthService.chats);

      const user = AuthService.getUser();
      user['status'] = 1;
      this.socketService.sendStatus(user);

      this.socketService.onNewStatus().subscribe(user => {
        //console.log('New status ' + user['status'] + ' from ' + user.username);

        if(AuthService.chats) {
          AuthService.chats.map(x => {
            if(x.to.id == user.id) {
              x.to.last_login = moment().format('YYYY-MM-DD HH:mm:ss');
              x.status = user['status'];
            }
          });
        }
      });

      this.socketService.onReceivePresence().subscribe(user => {
        //console.log('receiving presence from ' + user.username);

        if(AuthService.chats) {
          AuthService.chats.map(x => {
            if (x.to.id == user.id) {
              x.status = user['status'];
            }
          });
        }

        //console.log(AuthService.chats);
      });

      this.socketService.onDisconnected().subscribe(user => {
        //console.log(user.username + ' is disconnected');
        
        AuthService.chats.map(x => {
          if (x.to.id == user.id) {
            x.status = 0;
          }
        });
      });

      this.socketService.onNewChatMessage().subscribe(message => {
        this.socketService.sendMarkMessageReceived(message);

        console.log('New chat message <' + message.message + '> from ' + message.from.username + ' para ' + message.to.username);
        message.my = false;

        let newChat;
        if(!AuthService.chats.find(x => x.to.id == message.from.id)) {
          newChat = new ChatP(AuthService.getUser(), message.from, message.message, false);
          newChat.status = 1;
          newChat.messages = [];
          this.router.url != '/chat' ? newChat.messages.push(message) : null;
          newChat.countNewMessage = 1;
          AuthService.chats.unshift(newChat);
        }

        this.messageService.messageReceived(message);

        // AuthService.chats.map(x => {
        //   if(x.to.id == message.from.id) {
        //     x.countNewMessage += 1; 
        //   }
        // });

        if(this.router.url != '/chat' && !newChat) {
          let chatWindow = this.miniChatinstance.openChatWindow(AuthService.chats.find(x => x.to.id == message.from.id));

          AuthService.chats.map(x => {
            if(x.from.id == AuthService.getUser().id && x.to.id == message.from.id) {
              x.messages.push(message);
              chatWindow[0].hasFocus ? x.countNewMessage = 0 : x.countNewMessage += 1;
            }
          });
        }

        if(this.router.url != '/chat') {
          this.toastr.info(message.from.name + ': ' + message.message,
                          'Chat (' + AuthService.chats.find(x => x.to.id == message.from.id).countNewMessage + ' mensajes)')
                    .onTap.subscribe(x => {
                      this.router.navigate(['/chat']);
                      this.toastr.clear();
                    });

          if($('#icChat')[0]) {
            $($('#icChat')[0].children[0]).show();
          }
        }

        this.setCountIconChats();

        this.showDesktopNotification('Chat (' + AuthService.chats.find(x => x.to.id == message.from.id).countNewMessage + ' mensajes)', message.from.name + ': ' + message.message);
      });

      this.socketService.onMarkMessageSeen().subscribe(chat => {
        console.log('seeing messages from ' + chat.from.username);

        AuthService.chats.map(x => {
          if(x.from.id == AuthService.getUser().id && x.to.id == chat.from.id) {
            x.messages.map(x => {
              x.seen = true;
              x.received = true;
            });
          }
        });
      });

      this.socketService.onMarkMessageReceived().subscribe(chat => {
        console.log('receiving messages from ' + chat.to.username);

        AuthService.chats.map(x => {
          if(x.from.id == AuthService.getUser().id && x.to.id == chat.to.id) {
            x.messages.map(x => {
              x.received = x.id == chat.id ? true : x.received;
            });
          }
        });
      });

      this.socketService.onTyping().subscribe(chat => {
        console.log('PAGESCOMPONENT get typing from ' + chat.from.name);

        this.messageService.sendTyping(chat);
        // this.messageService.sendTyping1(chat);
      });

      this.socketService.onStopTyping().subscribe(chat => {
        console.log('PAGESCOMPONENT get stop-typing from ' + chat.from.name);
  
        this.messageService.sendStopTyping(chat);
      });

    });

    // this.menuService.getMenu().subscribe(items => {
    //   console.log(items);
    //   MenuService.menuItems = items;
    //   this.messageService.loadedMenu(true);
    // });
    // this.chatService.getChats(AuthService.getUser().id).subscribe(chats => {
    //   AuthService.chats = chats;

    //   console.log(AuthService.chats);
    //   this.socketService.getPresences(AuthService.getUser());
    // });
    
    console.log('INIT PAGES COMPONENT');
    if (window.innerWidth <= 768){
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }
    this.menuOption = this.settings.menu; 
    this.menuTypeOption = this.settings.menuType; 
    this.defaultMenu = this.settings.menu;

    let setShowNotif = (value: boolean) => {
      this.canShowNotif = value;
    };

    $(window).blur(function(){
      console.log("blur");
      setShowNotif(true);
    })
    $(window).focus(function(){
      console.log("focus");
      setShowNotif(false);
    })

      this.socketService.newProcedure().subscribe(data => {
          console.log(data);
          if(AuthService.checkPermissions(1) && AuthService.getUser().role.id != 4) { //solo los que tienen acceso al modulo de tramites, si un admin le asigna un tramite al alumno no le llega la notificacion
            this.toastr.info(data['message'], data['title']);
            this.showDesktopNotification(data['title'], data['message']);
          } else if(AuthService.getUser().id == data['userId']) {
            this.toastr.info(data['message'], data['title']);
            this.showDesktopNotification(data['title'], data['message']);
          }
      });

      this.socketService.newAnswerProcedure().subscribe(data => {
          console.log(data);
          
          if(AuthService.checkPermissions(1) && AuthService.getUser().role.id != 4) { //solo los que tienen acceso al modulo de tramites, si un admin le asigna un tramite al alumno no le llega la notificacion
            this.toastr.info(data['message'], data['title']);
            this.showDesktopNotification(data['title'], data['message']);
          } else if(AuthService.getUser().id == data['userId']) {
            this.toastr.info(data['message'], data['title']);
            this.showDesktopNotification(data['title'], data['message']);
          }
          
      });

      this.socketService.testDiscon().subscribe(data => {
          //console.log('test-discon');
      });

      //this.socketService.initListeners();

      

      this.socketService.onConnection().subscribe(user => {
        console.log('I am connected');
      });

      

    //   this.socketService.onConnected().subscribe(user => {
    //     console.log(user.username + ' is connected');

    //     // AuthService.setChats = AuthService.getChats.map(x => {
    //     //   if (x.to.id == user.id) {
    //     //     x.status = 1;
    //     //   }

    //     //   return x;
    //     // });
    // });

  }

  ngOnDestroy() {
  }

  initMiniChatComponent() {
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(NgChat).create(this.injector);        
    
      this.applicationRef.attachView(componentRef.hostView);
      
      let instance = <NgChat>componentRef.instance;
      this.miniChatinstance = instance;
      instance.adapter = new DemoAdapter();
      instance.userId = 444;
      instance.title = 'Chats (' + AuthService.chats.length + ')';

      instance.onUserChatOpened.subscribe(data => {

        setTimeout(() => {
          $('.mini-chat .mat-list-item-content').css('padding', '0');

          // const measurer = this.measurer;
          // const updateTextAreaSize = (a) => {
          //   this.updateTextAreaSize(a) ;
          // };
          // const initMeasurerFor = (a) => {
          //   this.initMeasurerFor(a) ;
          // };

          // $('textarea.autofit').on({
          //   input: function(){      
          //   var text = $(this).val();  
          //   if($(this).attr("preventEnter") == undefined){
          //   text = text.replace(/[\n]/g, "<br>&#8203;");
          //   }
          //   measurer.html(text);                       
          //   updateTextAreaSize($(this));       
          //   },
          //   focus: function(){
          //     initMeasurerFor($(this));
          //   },
          //   keypress: function(e){
          //   if(e.which == 13 && $(this).attr("preventEnter") != undefined){
          //   e.preventDefault();
          //   }
          //   }
          //   });
        });

      });

      instance.onSentMessage.subscribe(x => {
        setTimeout(() => {
          $('.mini-chat .mat-list-item-content').css('padding', '0');

          // $('#textAreaMessage').val('');
        });
      });

      instance.onNewMessageReceived.subscribe(x => {
        setTimeout(() => {
          $('.mini-chat .mat-list-item-content').css('padding', '0');
        });
      });
  
      const elem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      
      const divChat = document.getElementById('divChat');        
      divChat.appendChild(elem); 
  }

  setCountIconChats() {
    if(this.router.url != '/chat') {
      const componentRef = this.componentFactoryResolver.resolveComponentFactory(IconChatsComponent).create(this.injector);        
        
      this.applicationRef.attachView(componentRef.hostView);
          
      let instance = <IconChatsComponent>componentRef.instance;

      let count = 0;

      AuthService.chats.filter(x => {
        count += x.countNewMessage;
      });

      instance.countChatMessage = count;

      const elem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        
      const sidenav = document.getElementById('divIconChats');        
      sidenav.replaceChild(elem, sidenav.children[0]);     
    }
  }

  ngAfterViewInit(){
    setTimeout(() => { this.settings.loadingSpinner = false; }, 300);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.settings.sidenavIsPinned) {
          this.sidenav.close();
        }
        if(window.innerWidth <= 768){
          this.sidenav.close();
        }
      }
    });
    if(this.settings.menu == "vertical")
      this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems());
  }

  public chooseMenu() {
    this.settings.menu = this.menuOption;
    this.defaultMenu = this.menuOption;
    this.saveSettings();

    this.router.navigate(['/']);
  }

  public chooseMenuType() {
    this.settings.menuType = this.menuTypeOption;
    this.saveSettings();
  }

  public changeTheme(theme) {
    this.settings.theme = theme;
    this.saveSettings();
  }

  public changeSidenavIsOpened() {
    this.settings.sidenavIsOpened = !this.settings.sidenavIsOpened;
    this.saveSettings();
  }

  public changeSidenavIsPinned() {
    this.settings.sidenavIsPinned = !this.settings.sidenavIsPinned;
    this.saveSettings();
  }

  public changeSidenavIsUserBlock() {
    this.settings.sidenavUserBlock = !this.settings.sidenavUserBlock;
    this.saveSettings();
  }

  public saveSettings() {
    const settings = this.settings;
    settings['userId'] = AuthService.getUser().id;

    this.http.post('/api/saveSettings', settings ).subscribe(settings => {
      console.log(settings);

      const user = AuthService.getUser();
      user.settings = this.settings;

      sessionStorage.setItem('user', JSON.stringify(user));
    });
  }

  public toggleSidenav() {
    this.sidenav.toggle();
  }

  public onPsScrollY(event) {
    this.scrolledContent = event.target;
    (this.scrolledContent.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false; 
    if (this.settings.menu == 'horizontal') {
      if (this.settings.fixedHeader){
        var currentScrollTop = (this.scrolledContent.scrollTop > 56) ? this.scrolledContent.scrollTop : 0;   
        (currentScrollTop > this.lastScrollTop) ? this.isStickyMenu = true : this.isStickyMenu = false;
        this.lastScrollTop = currentScrollTop; 
      } 
      else{
        (this.scrolledContent.scrollTop > 56) ? this.isStickyMenu = true : this.isStickyMenu = false;  
      }
    } 
  }

  public scrollToTop(){
    var scrollDuration = 200;
    var scrollStep = -this.scrolledContent.scrollTop / (scrollDuration / 20);
    var scrollInterval = setInterval(()=>{
      if(this.scrolledContent.scrollTop != 0){
         this.scrolledContent.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval); 
      }
    },10);
    if(window.innerWidth <= 768){
      this.scrolledContent.scrollTop = 0;
    }
  }

  @HostListener('window:resize')
  public onWindowResize():void {
    if(window.innerWidth <= 768){
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical'
    }
    else{
      (this.defaultMenu == 'horizontal') ? this.settings.menu = 'horizontal' : this.settings.menu = 'vertical'
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  public closeSubMenus(){
    let menu = document.querySelector(".sidenav-menu-outer");
    if(menu){
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if(child){
          if(child.children[0].classList.contains('expanded')){
              child.children[0].classList.remove('expanded');
              child.children[1].classList.remove('show');
          }
        }
      }
    }
  }

  showDesktopNotification(title: string, body: string) {
    
    if(this.canShowNotif) {
      this.notificationService.generateNotification({
        title: title,
        body: body,
        icon: 'assets/img/app/blue_logo_cnci.png',
    });
      //   webNotification.showNotification(title, {
      //     body: body,
      //     icon: 'assets/img/app/blue_logo_cnci.png',
      //     onClick: function onNotificationClicked() {
      //         console.log('Notification clicked.');
      //     },
      //     autoClose: 4000 //auto close the notification after 4 seconds (you can manually close it via hide function)
      // }, function onShow(error, hide) {
      //     if (error) {
      //         window.alert('Unable to show notification: ' + error.message);
      //     } else {
      //         console.log('Notification Shown.');
  
      //         setTimeout(function hideNotification() {
      //             console.log('Hiding notification....');
      //             hide(); //manually close the notification (you can skip this if you use the autoClose option)
      //         }, 5000);
      //     }
      // });
    }
  }

}